module.exports = __webpack_public_path__ + "static/img/14046B_2_R_20190227_fit.dbd8cf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14046B_2_R_20190227_fit.png
// module id = 5yFi
// module chunks = 0